import React from "react";

import { AccountRoutes, ApplicationBaseRoutes } from "src/routes";
import { HeaderLinkProps } from "../constants";
import { RouterLink } from "src/_shared/ThemeTwo/Link/router-link.component";

export const AccountHistory: React.FC<HeaderLinkProps> = ({ variant, linkLabel, onClickCallback }) => (
  <RouterLink.siteHeader
    variant={variant}
    to={`${ApplicationBaseRoutes.account}${AccountRoutes.history}`}
    onClick={onClickCallback}
  >
    {linkLabel}
  </RouterLink.siteHeader>
);
